import { api } from './api';

export const userService = {
    getUser: async (userId) => {
        const response = await api.get(`/users/${userId}`);
        return response.data;
    },
    
    getCurrentUser: () => {
        return api.get('/users/me');
    },
    
    updateProfile: async (userData) => {
        try {
            const response = await api.put('/users/profile', userData);
            return response.data;
        } catch (error) {
            console.error('Error updating profile:', error);
            throw error;
        }
    },
    
    getAllUsers: () => {
        return api.get('/users/members');
    },
    
    getMembers: async () => {
        const response = await api.get('/users/members');
        return response.data;
    },
    
    async searchUsers(query) {
        const response = await api.get(`/users/search?q=${encodeURIComponent(query)}`);
        return response.data;
    },
    
    // ... other existing methods
}; 